document.addEventListener('DOMContentLoaded', () => {

  /* ── Storage helpers ── */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('wishlist_items') || '[]'); }
    catch { return []; }
  }

  function saveWishlist(items) {
    localStorage.setItem('wishlist_items', JSON.stringify(items));
    /* legacy key — keep IDs list in sync for any other code that reads it */
    localStorage.setItem('wishlist', JSON.stringify(items.map(p => String(p.id))));
    updateWishlistUI();
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  }

  function isWishlisted(productId) {
    return getWishlist().some(p => String(p.id) === String(productId));
  }

  /* ── Toggle ── */
  function toggleWishlist(btn) {
    const productId = btn.dataset.wishlistProduct;
    let items = getWishlist();

    if (isWishlisted(productId)) {
      items = items.filter(p => String(p.id) !== String(productId));
    } else {
      /* collect product data from the button's data attributes */
      items.push({
        id:     productId,
        handle: btn.dataset.wishlistHandle  || '',
        title:  btn.dataset.wishlistTitle   || '',
        url:    btn.dataset.wishlistUrl     || `/products/${btn.dataset.wishlistHandle}`,
        image:  btn.dataset.wishlistImage   || ''
      });
    }

    saveWishlist(items);
  }

  /* ── UI sync ── */
  function updateWishlistUI() {
    const items = getWishlist();
    const ids   = items.map(p => String(p.id));

    document.querySelectorAll('[data-wishlist-product]').forEach(btn => {
      btn.classList.toggle('is-active', ids.includes(String(btn.dataset.wishlistProduct)));
    });

    const badge = document.getElementById('wishlist-count');
    if (badge) {
      const count = items.length;
      badge.textContent    = count;
      badge.style.display  = count === 0 ? 'none' : 'flex';
    }
  }

  /* ── Click delegation ── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-product]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(btn);
  });

  /* ── Init ── */
  updateWishlistUI();

  window.Wishlist = {
    getItems: getWishlist
  };

});